module.exports = __webpack_public_path__ + "img/icon-usdt.f768b765.png";